import { NgModule } from '@angular/core';
import {
  AuthorizeDirective,
  BackButtonDirective,
  DebounceClickDirective,
  DynamicFormRowDirective,
  GooglePlacesDirective,
  ResizeColumnDirective,
  TooltipIfEllipsisDirective,
  TsEmptyDefaultDirective,
  CellTextWrapDirective,
  AutocompletePanelZoomDirective,
  QuillEditorStylingDirective,
} from './index';
import { CommonModule } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';

const DIRECTIVES = [
  AuthorizeDirective,
  BackButtonDirective,
  DebounceClickDirective,
  DynamicFormRowDirective,
  GooglePlacesDirective,
  ResizeColumnDirective,
  TooltipIfEllipsisDirective,
  TsEmptyDefaultDirective,
  CellTextWrapDirective,
  AutocompletePanelZoomDirective,
  QuillEditorStylingDirective,
];

@NgModule({
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES],
  providers: [MatTooltip],
  imports: [CommonModule, MatAutocompleteModule],
})
export class DirectivesModule {}
